import { Directive, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: 'input[clearOnPaste]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RemoveOnPasteDirective),
      multi: true
    }
  ],
  host: {
    '(change)': 'onChange($event.target.value)',
    '(blur)': 'onTouched()',
    '(paste)': 'onPaste($event)'
  }
})
export class RemoveOnPasteDirective implements ControlValueAccessor {

  @Input() removeRegex: string;

  onChange: (_: any) => void;
  onTouched: () => void;

  constructor(private elementRef: ElementRef<HTMLInputElement>, private renderer: Renderer2) { }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
  }

  onPaste(event: any): void {
    let value = event.clipboardData.getData('text/plain');
    if (value != null) {
      value = value.replace(new RegExp(this.removeRegex, 'g'), '');
    }
    this.onChange(value);
    setTimeout(() => this.renderer.setProperty(this.elementRef.nativeElement, 'value', value), 0);
  }
}

